import * as React from 'react';
import { TextField, IconButton, InputLabel, FormHelperText } from '@mui/material';
import dayjs from 'dayjs';
import 'dayjs/locale/en-au';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export const Date = ({ id, value, updateValue, path, description, errors, visible, label }) => {
  // console.log('value', value)
  const [dateValue, setDateValue] = React.useState(value ? dayjs(value, 'DD-MM-YYYY') : null);

  const handleChange = (value) => {
    setDateValue(value)
    updateValue(value.format('DD-MM-YYYY'));
  };

  return (
    <div id={`#/properties/${path}`} className={path} style={{ display: visible ? 'block' : 'none' }}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-au">
        <DatePicker
          label={label}
          value={dateValue}
          onChange={handleChange}
          slotProps={{ textField: { fullWidth: true } }}
          format="DD-MM-YYYY"
        />
      </LocalizationProvider>
      { errors &&
        <FormHelperText error={true} filled={true}>{errors}</FormHelperText>
      }
    </div>
  );
};
